/* eslint-disable react/no-danger */
import React from 'react';
import { Modal, Card } from 'semantic-ui-react';
import { ANNUAL_PRICE_PERIOD, MONTHLY_PRICE_PERIOD } from '../PublishBanner.constants';
import { SubscriptionsContextConsumer } from '../PublishBanner.context';
import { formatCentsToDollars } from '../PublishBanner.formatters';
export default function PeriodSelect() {
  return /*#__PURE__*/React.createElement(SubscriptionsContextConsumer, null, function (_ref) {
    var selectedSubscription = _ref.selectedSubscription,
      onSelectPeriod = _ref.onSelectPeriod;
    if (!selectedSubscription) {
      return null;
    }
    var priceTitle = selectedSubscription.priceTitle,
      annualDescription = selectedSubscription.annualDescription,
      monthlyDescription = selectedSubscription.monthlyDescription,
      annualPrice = selectedSubscription.annualPrice,
      monthlyPrice = selectedSubscription.monthlyPrice;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Header, {
      className: "modal-header"
    }, "Select a subscription period"), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement("h2", {
      className: "header-text blue-color"
    }, priceTitle), /*#__PURE__*/React.createElement("div", {
      className: "period-select-container"
    }, /*#__PURE__*/React.createElement(Card, {
      className: "period-card",
      onClick: function onClick() {
        return onSelectPeriod(ANNUAL_PRICE_PERIOD);
      }
    }, /*#__PURE__*/React.createElement(Card.Content, null, /*#__PURE__*/React.createElement("h2", {
      className: "blue-color left-aligned"
    }, "Annually"), /*#__PURE__*/React.createElement("div", {
      className: "annual-period-card"
    }, /*#__PURE__*/React.createElement("p", {
      className: "annual-period-card-first",
      dangerouslySetInnerHTML: {
        __html: annualDescription
      }
    }), /*#__PURE__*/React.createElement("h3", {
      className: "green-color annual-period-card-second"
    }, "SAVE $", formatCentsToDollars(monthlyPrice * 12 - annualPrice))), /*#__PURE__*/React.createElement("p", {
      className: "left-aligned body-text"
    }, "Billed as one payment of $", formatCentsToDollars(annualPrice))))), /*#__PURE__*/React.createElement("div", {
      className: "period-select-container"
    }, /*#__PURE__*/React.createElement(Card, {
      className: "period-card",
      onClick: function onClick() {
        return onSelectPeriod(MONTHLY_PRICE_PERIOD);
      }
    }, /*#__PURE__*/React.createElement(Card.Content, null, /*#__PURE__*/React.createElement("div", {
      className: "annual-period-card-first"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "blue-color"
    }, "Monthly"), /*#__PURE__*/React.createElement("p", null, monthlyDescription)))))));
  });
}